import { FC, HTMLAttributes } from 'react';
import { cn } from '../../utility/cn';


export const Card: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={cn('card mb-5 mb-xl-10', className)} {...props}>{children}</div>
);

export const CardHeader: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={cn('card-header', className)} {...props}>
        <div className="card-title m-0 flex-column d-flex">
            {children}
        </div>
    </div>
);

export const CardTitle: FC<HTMLAttributes<HTMLHeadingElement>> = ({ children, className }) => (
    <h3 className={cn("fw-bolder", className)}>{children}</h3>
);

export const CardDescription: FC<HTMLAttributes<HTMLHeadingElement>> = ({ children, className }) => (
    <span className={cn("text-muted mt-1 fw-bold fs-7", className)}>{children}</span>
);


export const CardBody: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={cn('card-body', className)} {...props}>{children}</div>
);

export const CardFooter: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, style, ...props }) => (
    <div className={cn('card-footer d-flex', className)} {...props}>{children}</div>
);